import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import ChangedValueIndicator from './_changed-value-indicator.js'
import Image from './_image.js'
import SuspendedSelectionLabel from './_suspended-selection-label.js'

export default {
  name: 'Odds',
  values: {
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          alignItems: 'flex-start',
          flexGrow: 0,
        },
      },
    },
    suspendedInfo: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    updatedPrice: {
      configSet: FlexPane,
      configValues: {
        style: {
          justifyContent: 'center',
          alignItems: 'center',
          padding: '4px',
          maxHeight: '14px',
        },
      },
    },
    priceContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          justifyContent: 'flex-end',
        },
      },
    },
    priceBoostIndicator: {
      configSet: ChangedValueIndicator,
      configValues: {
        container: {
          style: {
            alignItems: 'center',
          },
        },
        indicationIcon: {
          src: 'double-arrow-right',
          style: {
            minWidth: '12px',
            minHeight: '12px',
          },
        },
      },
    },
    bestOddsIcon: {
      configSet: Image,
      configValues: {
        src: 'racing-bestodds',
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    suspendedSelectionLabel: {
      configSet: SuspendedSelectionLabel,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
